import { apiGet } from '../client';
import { BusinessMetricsSchema, type BusinessMetrics } from '../schemas';

/**
 * `from`/`to` are optional ISO instants; omitting either lets the backend
 * apply its own default (the caller's last 30 days), so the dashboard never
 * has to duplicate that default here.
 */
export function getBusinessMetrics(from?: string, to?: string): Promise<BusinessMetrics> {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  const query = params.toString();
  return apiGet(`/v1/business/metrics${query ? `?${query}` : ''}`, BusinessMetricsSchema);
}
